export default __webpack_public_path__ + "static/media/tabela.ac00bb28.svg";